@if (storeV2.isAllowed('folder.update')()) {
    <div class="dialogButtons">
        @if (expertiseCode === '925') {
            <app-button
                [disabled]="!folderStore.canEdit()"
                label="voucher.DP"
                icon="pi-plus"
                (clickEvent)="create('dp')"
            ></app-button>
        }
        @if (expertiseCode === '913') {
            <app-button
                [disabled]="!folderStore.canEdit()"
                label="voucher.ORP"
                icon="pi-plus"
                (clickEvent)="create('orp')"
            ></app-button>
        }
        @if (expertiseCode === '902') {
            <app-button
                [disabled]="!folderStore.canEdit()"
                label="voucher.FT"
                icon="pi-plus"
                (clickEvent)="create('ft')"
            ></app-button>
        }
    </div>
}

@let vouchers = storeV2.data.getVouchers();
@if (vouchers) {
    <app-table
        #voucherTable
        translatePrefix="folder.voucher.listTable."
        [columns]="columns()"
        [gridData]="$any(vouchers)"
        [hideCheckboxes]="true"
        [refreshCallback]="storeV2.api.getVouchers"
        [refreshCallbackFragment]="vouchersFrag"
        [additionalFilter]="additionalFilter()"
        (detailCallback)="showDetail($event)"
        (deleteCallbackWithEvent)="deleteVoucher($event)"
        [showDelete]="folderStore.canEdit()"
        [defaultSorters]="[{ column: 'issueDate', direction: 'DESC' }]"
    >

        <ng-template pTemplate="nursingCare" let-item="item">
            <app-button
                svgIcon="clipboard2-pulse"
                [text]="true"
                styleClass="tableIcon"
                [pTooltip]="'folder.voucher.nursingCareLink' | translate"
                (clickEvent)="navigateToPlan(item)"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="copy" let-item="item">
            <app-button
                icon="pi-copy"
                [text]="true"
                styleClass="tableIcon"
                [pTooltip]="'folder.voucher.listTable.fields.copy' | translate"
                (clickEvent)="copyVoucher(item)"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="print" let-item="item">
            <app-button
                icon="pi-print"
                [text]="true"
                styleClass="tableIcon"
                [pTooltip]="'folder.voucher.listTable.fields.print' | translate"
                (clickEvent)="openExportDialog(item)"
            ></app-button>
        </ng-template>

        <ng-template pTemplate="sequenceNumber" let-data="data">
            <div class="flex gap-small align-items-center">
                <div>{{ data.seqNumber }}</div>
                @if (data.showWarning) {
                    <i
                        class="pi pi-exclamation-triangle text-warning"
                        [pTooltip]="'voucher.messages.sequenceNumberLineNotContinual' | translate"
                    ></i>
                }
            </div>
        </ng-template>

        <ng-template pTemplate="primaryDiagnosisCode" let-item="item">
            {{ item.primaryDiagnosis?.code }}
        </ng-template>

        <ng-template pTemplate="issueDate" let-data="data">
            {{ data | shortDate }}
        </ng-template>

        <ng-template pTemplate="voucherTo" let-item="item" let-data="data">
            @if (item.closureDate) {
                <span [class.text-warning]="item.closureDate"
                    [pTooltip]="('folder.voucher.listTable.originalValidTo' | translate) + ': ' + (item.validTo | shortDate)">{{ data | shortDate }}
                </span>
            } @else {
                <div>{{ data | shortDate }}</div>
            }
        </ng-template>

    </app-table>
}
